module.exports = __webpack_public_path__ + "static/editorial-new-regular-a99852ce146ac064ea57f19ab078e1ed.woff2";